/**
 * NPC buyer definitions
 * Phase 1: Camp Chef only
 */

import { BuyerDefinition } from '@/types';

/**
 * All buyers in the game
 */
export const BUYER_DEFINITIONS: BuyerDefinition[] = [
  {
    id: 'camp_chef',
    name: 'Camp Chef',
    description: 'Friendly cook who buys any fish for fair prices.',
    priceMultiplier: 1.0, // Standard pricing
    availableInZones: ['mountain_lake'],
    icon: '👨‍🍳',
  },

  // Future buyers (Phase 2+)
  // {
  //   id: 'sushi_restaurant',
  //   name: 'Sushi Restaurant',
  //   description: 'High-end restaurant that pays premium for quality.',
  //   priceMultiplier: 1.3,
  //   preferences: {
  //     qualityRequirement: 'good', // Only buys Good+
  //     favorsQuality: ['excellent'], // +50% for Excellent
  //   },
  //   availableInZones: ['mountain_lake', 'coastal_ocean'],
  //   icon: '🍣',
  // },
  // {
  //   id: 'fish_market',
  //   name: 'Fish Market',
  //   description: 'Bulk buyer who pays less but accepts anything.',
  //   priceMultiplier: 0.8,
  //   availableInZones: ['coastal_ocean'],
  //   icon: '🏪',
  // },
];

/**
 * Buyer lookup by ID (for fast access)
 */
const BUYER_MAP = new Map(BUYER_DEFINITIONS.map((buyer) => [buyer.id, buyer]));

/**
 * Get buyer definition by ID
 * @throws Error if buyer not found
 */
export function getBuyerDefinition(id: string): BuyerDefinition {
  const buyer = BUYER_MAP.get(id);
  if (!buyer) {
    throw new Error(`Buyer not found: ${id}`);
  }
  return buyer;
}

/**
 * Get all buyers available in a specific zone
 */
export function getBuyersInZone(zoneId: string): BuyerDefinition[] {
  return BUYER_DEFINITIONS.filter((buyer) => buyer.availableInZones.includes(zoneId));
}

/**
 * Check if buyer ID exists
 */
export function buyerExists(id: string): boolean {
  return BUYER_MAP.has(id);
}
